import { FC } from 'react';

import { PlanFeature } from '../../../application/types';
import {
	IconContainerStyled,
	IconStyled,
	PlanFeaturesListItemContainerStyled,
	PlanFeatureTextStyled,
} from './PlanFeaturesListItem.styles';

interface PlanFeaturesListItemProps {
	feature: PlanFeature;
	isActive: boolean;
}

export const PlanFeaturesListItem: FC<PlanFeaturesListItemProps> = ({ feature, isActive }) => (
	<PlanFeaturesListItemContainerStyled>
		<IconContainerStyled isActive={isActive}>
			<IconStyled isActive={isActive} />
		</IconContainerStyled>
		<PlanFeatureTextStyled isIncludedInFree={feature.includedInFree} active={isActive}>
			{feature.text}
		</PlanFeatureTextStyled>
	</PlanFeaturesListItemContainerStyled>
);
